import {remove} from 'ramda'

export default (array, index) => {
  const value = array[index]
  if (value.isNew)
    return remove(index, 1, array)
  value.markDeleted(!value.isDeleted)
  return array
}
